<template>
  <div ref="banner" class="generic-banner text-white"  :style="{ '--top-scroll': bannerScrollOffset, '--header-bg': `url(${require('@/assets/' + image.replace(/^\//g, ''))})` }">
    <div class="container-fluid px-0 px-md-4 px-lg-5 mx-2 mx-md-4 mx-lg-5">
      <div class="banner-content">
        <div><slot></slot></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onMounted, onUnmounted, Ref, ref } from "vue"

  const props = defineProps<{
    image: string;
  }>();

  var banner: Ref<any> = ref();
  var bannerScrollOffset: Ref<any> = ref();
  function bannerScrollUpdate () {
    bannerScrollOffset.value = calcScrollOffset() + "px";
  }
  
  function calcScrollOffset () {
    const extraOffset = 40;
    return window.scrollY - (banner.value.offsetTop + extraOffset);
  }

  onMounted(async () => {
    bannerScrollOffset.value = calcScrollOffset() + "px";
    window.addEventListener('scroll', bannerScrollUpdate);
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', bannerScrollUpdate);
  })
</script>

<style lang="scss" scoped>
  .generic-banner {
    position: relative;
    background-image: var(--header-bg);
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    background-position-y: calc(50% + (var(--top-scroll) * 0.2));
  }
</style>